<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <el-form-item
          label="日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="截止日期"
            placeholder="选择时间范围"
          />
        </el-form-item>
        <el-form-item label="主体">
          <el-select
            v-model="query.marketId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result
      :is-export="false"
      @export="toDownload"
    />
    <!-- 表格 -->
    <el-table
      ref="zTable"
      :data="tableData"
    >
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="number"
        label="业务编号"
      />
      <af-table-column
        fixed
        prop="bizDate"
        label="业务日期"
      />
      <af-table-column
        fixed
        prop="unbackQty"
        label="未返吨数"
      />
      <af-table-column
        prop="price"
        label="价格"
      />
      <af-table-column
        prop="unbackAmt"
        label="未返金额"
      />
      <af-table-column
        prop="withholdQty"
        label="扣款吨数"
      />
      <af-table-column
        prop="withholdAmt"
        label="扣款金额"
      />
      <af-table-column
        prop="backQty"
        label="返还吨数"
      />
      <af-table-column
        prop="backAmt"
        label="返还金额"
      />
      <!-- 暂不实现 -->
      <!-- <af-table-column
        prop=""
        label="最后结算合约">
      </af-table-column> -->
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentNo"
      :total="total"
      background
      @current-change="changePage"
    />
  </div>
</template>
<script>
import api from '@/api'
import {
  getFirstDayOfCurrentMonth
} from '@/utils/util.js'

function Query () {
  this.userId = JSON.parse(localStorage.getItem('pro__USER_INFO')).value.userId || ''
  this.date = [getFirstDayOfCurrentMonth(), new Date()]
  this.marketId = '000'
}
export default {
  name: 'DepositPurchase',
  data () {
    return {
      query: new Query(),
      currentNo: 1,
      total: 0,
      pageSize: 10,
      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        currentNo: this.currentNo,
        pageSize: this.pageSize
      }
      this.query.date = this.query.date ? this.query.date : []
      param.beginDate = this.query.date.length ? this.$dayjs(this.query.date[0]).format('YYYYMMDD') : ''
      param.endDate = this.query.date.length ? this.$dayjs(this.query.date[1]).format('YYYYMMDD') : ''
      let res = await api.productLineReport.depositPurchase(param)
      this.total = res.data.totalElements
      this.tableData = res.data.rows
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
    // 导出
    toDownload () {

    }
  }
}

</script>
